import { LocationModel } from '@modules/location/location-model';

const { fields } = LocationModel;

export default [
  fields.name,
  fields.information,
];
